<template>
  <div class="invitationManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-invitationManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <!-- <span>招生CRM</span>
              <span>></span>-->
              <span class="c-normal">{{
                $t("Invitationauditionmanage.br")
              }}</span>
            </div>
          </div>
          <div class="invitationManage-container">
            <div class="content content-special">
              <div class="content-nav--head text-1 Tab-nav-head">
                <div class="c-n--head_lf">
                  <ul class="filter-condition">
                    <li
                      v-for="(item, index) in filtersOption"
                      :key="index"
                      :class="{ 'link-active': index == current }"
                      @click="addClass(index)"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
                <div class="c-n--head_rt">
                  <el-button type="primary" @click="daochu">
                    {{ $t("Common.btn_export") }}
                  </el-button>
                  <!-- *************暂时隐藏***************** -->
                  <!-- <el-button type="primary">导出</el-button> -->
                  <!-- <el-button type="primary">转回招生线索</el-button> -->
                </div>
              </div>
              <div class="flex-wrap pl20 pr20">
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666"
                    >{{ $t("Invitationauditionmanage.ed") }}:</span
                  >
                  <div class="time-box">
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Invitationauditionmanage.ae')"
                      v-model="selectForm.startTime"
                      value-format="yyyy-MM-dd"
                      style="width: 140px"
                      @change="handleSelect()"
                    ></el-date-picker>
                    <span class="ml10 mr10 fs14">{{
                      $t("Invitationauditionmanage.af")
                    }}</span>
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Invitationauditionmanage.ag')"
                      v-model="selectForm.endTime"
                      value-format="yyyy-MM-dd"
                      style="width: 140px"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666"
                    >{{ $t("Invitationauditionmanage.eb") }}:</span
                  >
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      v-model="selectForm.visitingTime"
                      class="mr15"
                      style="width: 120px"
                      clearable
                      :placeholder="$t('Invitationauditionmanage.al')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in VisitingtimeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <!--<span class="mr10 fs14 color-666">{{
                    $t("Invitationauditionmanage.ah")
                  }}</span>-->
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.chiefPerson"
                      style="width: 160px"
                      :placeholder="$t('Invitationauditionmanage.ec')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in chiefPerson"
                        :key="item.marketer_id"
                        :label="item.marketer_name"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.coursetype_id"
                      @change="handleSelect"
                      :placeholder="$t('Invitationauditionmanage.ee')"
                      style="width: 160px"
                    >
                      <el-option
                        v-for="item in selectForm.courseTypeList"
                        :key="`${item.coursetype_cnname}${item.coursetype_id}`"
                        :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                        :value="item.coursetype_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.crm_stu_type"
                      style="width: 160px"
                      :placeholder="$t('Invitationauditionmanage.ef')"
                      @change="handleSelect()"
                    >
                      <el-option label="新生跟踪" value="1"></el-option>
                      <el-option label="流失跟踪" value="2"></el-option>
                    </el-select>
                  </div>
                </div>

                <template v-if="current === 4">
                  <div class="flex-al mb10 mr10">
                    <div class="select-box">
                      <el-select
                        filterable
                        clearable
                        v-model="selectForm.invite_allisvisit"
                        style="width: 160px"
                        placeholder="请选择柜询状态"
                        @change="handleSelect()"
                      >
                        <el-option label="待确认" value="0"></el-option>
                        <el-option label="已到访" value="1"></el-option>
                        <el-option label="未到访" value="-1"></el-option>
                        <el-option label="已改约" value="2"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="flex-al mb10 mr10">
                    <div class="select-box">
                      <el-select
                        filterable
                        clearable
                        v-model="selectForm.cg_coursetype_id"
                        @change="handleSelect"
                        placeholder="请选择报名班组"
                        style="width: 160px"
                      >
                        <el-option
                          v-for="item in selectForm.courseTypeList"
                          :key="`${item.coursetype_cnname}${item.coursetype_id}`"
                          :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                          :value="item.coursetype_id"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </template>

                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      style="width: 350px"
                      clearable
                      :placeholder="$t('Invitationauditionmanage.eg')"
                      @change="handleSelectKeyword()"
                      class="input-cont"
                      v-model="selectForm.keyword"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelectKeyword()"
                    >{{ $t("Invitationauditionmanage.ap") }}</el-button
                  >
                </div>
              </div>
              <div class="tableList" ref="auto_height_table">
                <TableList
                  :list="tableData"
                  :options="optionscaozuo"
                  :columns="columns"
                  :operates="operates"
                  :issetting="true"
                  :tableOperate="tableOperate"
                  @toggleEditableColumn="toggleEditableColumn"
                  @handleColumnChange="handleColumnChange"
                ></TableList>
              </div>

              <el-pagination
                style="margin-top: 35px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>
    <!-- 已到访 -->
    <el-dialog
      title="柜询成功"
      :visible.sync="visitedJG"
      class="tan-binding"
      width="520px"
      :before-close="handleClose"
    >
      <div class="create">
        <div class="delTips tc">
          {{ studentName_invited }}{{ $t("Invitationauditionmanage.da") }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <template
          v-if="
            scopedData &&
            (scopedData.is_forbid != 1 || scopedData.client_tracestatus == 4)
          "
        >
          <template v-if="scopedData.invite_type == 0">
            <el-button
              :disabled="
                (scopedData.isgmcIndschoolenter == 1 &&
                  scopedData.isgmcschoolenter != 1) ||
                !isPrincipal
              "
              type="primary"
              @click="ClickNoVisited(inviteInfor)"
              >{{ $t("Invitationauditionmanage.ar") }}</el-button
            >
            <el-button @click="visitedJG = false">{{
              $t("Invitationauditionmanage.as")
            }}</el-button>
          </template>
          <el-button
            type="primary"
            size="small"
            v-else-if="scopedData.invite_type == 1"
            @click="visitedJG = false"
          >
            确定
          </el-button>
        </template>
        <template v-else>
          <template v-if="scopedData && scopedData.invite_type == 0">
            <el-button type="primary" disabled>
              {{ $t("Invitationauditionmanage.ar") }}
            </el-button>
            <el-button @click="visitedJG = false">
              {{ $t("Invitationauditionmanage.as") }}
            </el-button>
          </template>
          <template v-else-if="scopedData && scopedData.invite_type == 1">
            <el-button type="primary" size="small" @click="visitedJG = false">
              确定
            </el-button>
          </template>
        </template> -->
        <div class="flex-all">
          <div></div>
          <div class="flex-al">
            <div class="flex-al mr10">
              <span class="color-orange fs14 mr10">
                仅名单负责人以及主管可直接跟进
              </span>
              <el-button
                :disabled="!isPrincipal && postbe_crmuserlevel != 1"
                type="primary"
                @click="ClickNoVisited(inviteInfor)"
              >
                继续跟进
              </el-button>
            </div>
            <el-button @click="visitedJG = false"> 关闭 </el-button>
          </div>
        </div>
      </span>
    </el-dialog>

    <!-- 未到访 -->
    <el-dialog
      title="取消柜询"
      :visible.sync="visitingJG"
      class="tan-binding"
      width="520px"
      :before-close="handleClose"
    >
      <div class="create">
        <div class="info-textarea">
          <el-form ref="form" :model="reasonForm" label-width="90px">
            <el-form-item :label="$t('Invitationauditionmanage.at')">
              <el-select
                filterable
                v-model="reasonForm.select"
                style="width: 300px"
                :placeholder="$t('Invitationauditionmanage.au')"
                @change="handleClickreson()"
              >
                <el-option
                  v-for="(item, index) in reasonOptinon"
                  :key="index"
                  :label="item.reason_note"
                  :value="item.reason_note"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label=" "
              prop="textarea"
              :rules="[
                {
                  required: true,
                  message: '请选择原因',
                },
              ]"
            >
              <el-input
                clearable
                type="textarea"
                style="width: 300px"
                :placeholder="$t('Invitationauditionmanage.av')"
                v-model="reasonForm.textarea"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <template
          v-if="
            scopedData &&
            (scopedData.is_forbid != 1 || scopedData.client_tracestatus == 4)
          "
        >
          <template v-if="scopedData.invite_type == 0">
            <el-button
              type="primary"
              :disabled="
                (scopedData.isgmcIndschoolenter == 1 &&
                  scopedData.isgmcschoolenter != 1) ||
                !isPrincipal
              "
              @click="ClickNoVisiting(inviteInfor)"
              >{{ $t("Invitationauditionmanage.ar") }}</el-button
            >
            <el-button @click="ClickNoFloow()">{{
              $t("Invitationauditionmanage.as")
            }}</el-button>
          </template>
          <el-button
            type="primary"
            size="small"
            v-else-if="scopedData.invite_type == 1"
            @click="ClickNoFloow"
          >
            确定
          </el-button>
        </template>
        <template v-else>
          <template v-if="scopedData && scopedData.invite_type == 0">
            <el-button type="primary" disabled>{{
              $t("Invitationauditionmanage.ar")
            }}</el-button>
            <el-button @click="ClickNoFloow()">{{
              $t("Invitationauditionmanage.as")
            }}</el-button>
          </template>
          <el-button
            type="primary"
            size="small"
            v-else-if="scopedData && scopedData.invite_type == 1"
            @click="ClickNoFloow"
          >
            确定
          </el-button>
          {{ scopedData && scopedData.audition_type }}
        </template> -->

        <div class="flex-all">
          <div></div>
          <div class="flex-al">
            <div class="flex-al mr10">
              <span class="color-orange fs14 mr10">
                仅名单负责人以及主管可直接跟进
              </span>
              <el-button
                :disabled="!isPrincipal && postbe_crmuserlevel != 1"
                type="primary"
                @click="ClickNoVisiting(inviteInfor)"
              >
                提交并继续跟进
              </el-button>
            </div>
            <el-button @click="ClickNoFloow()"> 提交 </el-button>
          </div>
        </div>
      </span>
    </el-dialog>
    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :showUserSliderBox="showSliderBoxSee"
        :createJG="createJG"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :isRoot="isRoot"
        :isshowfirst="true"
        :isForm="true"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @handleSliderClick="handleSliderClick"
        @Clickedit="Clickedit"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        @updateList="updateList"
      ></userSeeing>
    </SliderBox>
    <!-- 流失学员查看 -->
    <slider-box
      :showSliderBox="showLSSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <schoolSeeing
        :showUserSliderBox="showLSSliderBoxSee"
        :customerId="customerId"
        :sId="sId"
        :sType="sType"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :activeName="activeName"
        :isRoot="isRoot"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @Clickedit="Clickedit"
        @handleSliderClick="handleSliderClick"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        :campusrosterStuData="campusrosterStuData"
        studentType="1"
      ></schoolSeeing>
    </slider-box>
    <!-- 绑定学员 -->
    <el-dialog
      :title="$t('Invitationauditionmanage.aw')"
      :visible.sync="createJG"
      class="tan-binding"
      width="30%"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form
          label-width="120px"
          ref="BindstudentFrom"
          :model="BindstudentFrom"
        >
          <el-form-item
            :label="$t('Invitationauditionmanage.ax')"
            prop="name"
            :rules="[{ required: true, message: '请选择学员' }]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.name"
              remote
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 200px"
              :placeholder="$t('Invitationauditionmanage.ay')"
            >
              <el-option
                v-for="item in FriendName"
                :key="item.client_id"
                :value="item.client_id"
                :label="item.client_cnname"
              >
                {{ item.client_cnname }}
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Invitationauditionmanage.az')"
            prop="relation"
            :rules="[{ required: true, message: '请选择绑定关系' }]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.relation"
              style="width: 200px"
              :placeholder="$t('Invitationauditionmanage.ba')"
            >
              <el-option
                v-for="item in FriendRelation"
                :key="item.friendrelation_id"
                :value="item.friendrelation_name"
                :label="item.friendrelation_name"
                >{{ item.friendrelation_name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onBindSubmit()">{{
          $t("Invitationauditionmanage.bb")
        }}</el-button>
        <!-- <el-button @click="createJG = false">取 消</el-button> -->
      </span>
    </el-dialog>
    <!-- 跟班试听 中间-->
    <auditClass
      :leaningVisible="leaningVisible"
      :auditionGenre="auditionGenre"
      :Auditiontime="Auditiontime"
      @handClickcompare="handClickcompare"
      @handClickcancel="handClickcancel"
      @handleClose="handleCloseLean"
    ></auditClass>
    <!-- 编辑列 -->
    <el-dialog
      :title="$t('Invitationauditionmanage.bc')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="[
          $t('Invitationauditionmanage.bd'),
          $t('Invitationauditionmanage.be'),
        ]"
        v-model="oprateColumn"
        @change="Changeoprate()"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate()">{{
          $t("Invitationauditionmanage.bb")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 改约-->
    <SliderBox
      :showSliderBox="changeAppointVisible"
      sliderWidth="700px"
      @hideSliderBox="hideSliderSeeBox"
    >
      <change-appoint
        @hideUserSliderBox="hideSliderSeeBox"
        :clientId="clientId"
        :inviteId="inviteId"
        pageFrom="invite"
        @leaning="leaning"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        :ClassMessage="ClassMessage"
        @updatelist="getClientinviteData"
      ></change-appoint>
    </SliderBox>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
// import echarts from "echarts";
import SliderBox from "@/components/SliderBox";
import TableList from "@/components/Table/table.vue";
import userSeeing from "@/components/User/seeing.vue";
import ChangeAppoint from "@/components/User/change-appoint.vue";
import schoolSeeing from "@/components/User/schoolSeeing.vue";
import auditClass from "@/components/Class/Class.vue";
import storeInvitationauditionmanage from "./Invitationauditionmanage.js";
export default {
  name: "Invitationmanage-invitationManage",
  data() {
    return {
      sId: "",
      sType: "",
      campusrosterStuData: null,

      changeAppointVisible: false,

      isPrincipal: false,
      scopedData: null,
      openMenu: ["4"],
      showSliderBox: false,
      showSliderBoxSee: false,
      showLSSliderBoxSee: false,
      leaningVisible: false,
      loading: false,
      createJG: false,
      fullscreenLoading: true, //全屏loading
      settingVisible: false,
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      data: [],

      seeSliderTitle: this.$t("Invitationauditionmanage.bu"),
      inviteInfor: [],
      ClassMessage: {}, //选择的试听班级
      clientLevelNum: "", //存储意向星级数目
      customerId: "", // 客户id
      isTrack: false, //是否点击跟进
      isRoot: false,
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: "",
      },
      chiefPerson: [], //主负责人
      fu_chiefPerson: [], //副负责人
      FriendName: [], //用户绑定人员名称
      FriendRelation: [], //用户绑定关系
      followFormid: "",
      layoutVisible: false, //分配
      auditionGenre: "", //试听类型
      Auditiontime: "", //试听时间
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      // 已到访学生姓名
      studentName_invited: "",
      //筛选条件
      selectForm: {
        visitingTime: "",
        startTime: "",
        endTime: "",
        chiefPerson: "",
        crm_stu_type: "",
        invite_allisvisit: "",
        cg_coursetype_id: "",
        keyword: "",
        courseTypeList: [],
        coursetype_id: "",
      },
      //未到访原因
      reasonForm: {
        select: "",
        textarea: "",
      },
      reasonOptinon: [],
      input: "",
      select: "",
      imageUrl: "",
      current: 0,
      visitedJG: false,
      visitingJG: false,
      levelNum: 5, //侧边栏个数
      sliderWidth: "900px", //侧边栏宽度
      activeName: "first",
      filtersOption: [
        // this.$t("Invitationauditionmanage.bv"),
        this.$t("views.Invitationauditionmanage.invitationManage.5474xx7uu0k0"),
        this.$t("Invitationauditionmanage.ea"),
        this.$t("Invitationauditionmanage.eh"),
        "已改约",
        "全部",
      ],
      VisitingtimeOption: [
        {
          value: "0",
          label: this.$t("Invitationauditionmanage.al"),
        },
        {
          value: "1",
          label: this.$t("Invitationauditionmanage.by"),
        },
        {
          value: "2",
          label: this.$t("Invitationauditionmanage.bz"),
        },
        {
          value: "3",
          label: this.$t("Invitationauditionmanage.ca"),
        },
        {
          value: "4",
          label: this.$t("Invitationauditionmanage.cb"),
        },
      ],
      IsvisterReasonid: "",
      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: false, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
        // specialColumns:true//特殊列
      },
      columns: [],
      operates: {
        width: 200,
        label: this.$t(
          "views.Invitationauditionmanage.invitationManage.5474xx7uvsg0"
        ),
        align: "center",
        fixed: "right",
        list: [
          {
            id: "1",
            label: this.$t("Invitationauditionmanage.cc"),
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.scopedData = row;
              this.handleOneClick(row);
            },
          },
          {
            id: "2",
            label: this.$t("Invitationauditionmanage.cd"),
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.scopedData = row;
              this.isMarketerClientPrincipal();
              this.handleTwoClick(row);
            },
          },

          {
            id: "3",
            label: "改约",
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            changeAppoint: true,
            method: (index, row) => {
              this.scopedData = row;
              this.changeAppointVisible = true;
            },
          },
        ],
      }, // 列操作按钮
      tableOperate: {
        label: "11",
        operate: true,
        align: "center",
        fixed: "right",
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  components: {
    PageNav,
    TableList,
    SliderBox,
    auditClass,
    userSeeing,
    schoolSeeing,
    ChangeAppoint,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";

    // this.optionscaozuo.tableHeight=this.$Common.getTableHeight(400);//设置表格高度
    this.getClientinviteData();
    this.getVisitingtime(); //到访日时间
    this.getMarketer(); // 获取招生的负责人
    this.getCourseType();
    // this.getClientNameData();//绑定学员->获取人员名称
  },
  computed: {
    clientId() {
      return this.scopedData ? this.scopedData.client_id : "";
    },
    inviteId() {
      return this.scopedData ? this.scopedData.invite_id : "";
    },
  },
  methods: {
    isMarketerClientPrincipal() {
      storeInvitationauditionmanage
        .isMarketerClientPrincipal({
          invite_id: this.scopedData.invite_id,
        })
        .then((res) => {
          const { data } = res.data;
          this.isPrincipal = data.is_principal;
        });
    },
    getCourseType() {
      storeInvitationauditionmanage
        .getCourseType({
          ishaveopenclass: 1,
          marketer_id: this.$store.state.MARKETER_ID,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.selectForm.courseTypeList = [...data.list];
          } else {
            this.selectForm.courseTypeList = [];
          }
        });
    },
    updateList() {
      this.getClientinviteData();
    },
    // 柜询管理表格数据
    getClientinviteData() {
      console.log("getClientinviteData");
      storeInvitationauditionmanage
        .getClientinvite({
          coursetype_id: this.selectForm.coursetype_id,
          invite_allisvisit: this.selectForm.invite_allisvisit,
          cg_coursetype_id: this.selectForm.cg_coursetype_id,
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          invite_isvisit:
            this.current == 0
              ? "0"
              : this.current == 1
              ? "1"
              : this.current == 2
              ? "-1"
              : this.current == 3
              ? "2"
              : "",
          // 非必须传
          invite_visittime: this.selectForm.visitingTime,
          invite_starttime: this.selectForm.startTime,
          invite_endtime: this.selectForm.endTime,
          main_marketer_id: this.selectForm.chiefPerson,
          keyword: this.selectForm.keyword,
          crm_stu_type: this.selectForm.crm_stu_type,
        })
        .then((res) => {
          //
          this.tableData = res.data.data.list;
          this.dataNumber = parseInt(res.data.data.allnum);

          var Columns = res.data.data.field;
          this.allColumns = res.data.data.field;
          this.$Tool.setStorage("allinvitationColumns", this.allColumns);
          this.showColumn = JSON.parse(
            localStorage.getItem("showinvitationColumns")
          );
          var fieldColumns = res.data.data.field;
          if (JSON.parse(localStorage.getItem("showinvitationColumns"))) {
            Columns = this.showColumn;
            fieldColumns = this.showColumn;
          }
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            0
          );
          this.columns.forEach((v) => {
            if (v.prop == "client_tag") {
              this.$set(v, "istag", true);
              this.$set(v, "width", "220px");
            }
          });
          this.optionscaozuo.loading = false;
          var arr = [];
          var arr2 = [];
          fieldColumns.forEach((item, index) => {
            arr.push({
              key: index,
              label: item.fieldstring,
              disabled: item.custom === "0",
            });
            if (item.show == "0") {
              arr2.push(index);
            }
          });
          this.data = arr;
          this.oprateColumn = arr2;
          if (res.data.code !== 200) {
            this.optionscaozuo.errortip = res.data.msg;
          }
        });
    },
    // 柜询管理->设置到访或未到访 status:1为已到访,0为未到访
    postIsvisitData(status, id) {
      storeInvitationauditionmanage
        .postIsvisit({
          marketer_id: this.marketer_id,
          token: this.token,
          invite_id: id,
          invite_isvisit: status,
          invite_type: this.scopedData.invite_type,
          invite_novisitreason: this.reasonForm.textarea,
        })
        .then((res) => {
          // (() => {})(res.data);
          const { code, data, msg } = res.data;
          if (code === 200) {
            this.isPrincipal = data.is_principal;
            if (status == "1") {
              this.visitedJG = true;
            } else {
              this.visitingJG = false;
            }
            this.getClientinviteData();
          } else {
            this.$message.error(msg);
          }
        });
    },
    //获取到访日时间
    getVisitingtime() {
      var val0 = "";
      var val1 = this.$Common.getDate(0) + "," + this.$Common.getDate(0);
      var val2 = this.$Common.getDate(-1) + "," + this.$Common.getDate(-1);
      (() => {})(this.$Common.getWeekStartAndEnd(0));
      var val3 =
        this.$Common.getWeekStartAndEnd(0)[0] +
        "," +
        this.$Common.getWeekStartAndEnd(0)[1];
      var val4 =
        this.$Common.getMonthStartAndEnd(0)[0] +
        "," +
        this.$Common.getMonthStartAndEnd(0)[1];
      var data = [];
      this.VisitingtimeOption.forEach((element, index) => {
        switch (index) {
          case 0:
            element.value = val0;
            break;
          case 1:
            element.value = val1;
            break;
          case 2:
            element.value = val2;
            break;
          case 3:
            element.value = val3;
            break;
          case 4:
            element.value = val4;
            break;
          default:
            (() => {})("error");
            break;
        }
        data.push(element);
      });
      this.VisitingtimeOption = data;
    },
    // 获取招生的负责人
    getMarketer() {
      storeInvitationauditionmanage
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.chiefPerson = res.data.data.list;
        });
    },
    // 获取未到访原因模板
    getIsvisterReasonData() {
      storeInvitationauditionmanage
        .getIsvisterReason({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.reasonOptinon = res.data.data.list;
        });
    },
    // 原因选择
    handleClickreson() {
      (() => {})(this.reasonForm.select);
      this.reasonForm.textarea = this.reasonForm.select;
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.getClientinviteData();
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.getClientinviteData();
    },
    // 未到访继续跟进
    ClickNoVisiting(v) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postIsvisitData("-1", this.IsvisterReasonid);
          this.visitingJG = false;
          this.isRoot = true;
          this.isTrack = true; //是否点击我要跟进
          this.from_client_id = v.client_id;
          this.followFormid = v.client_id; //跟进
          this.customerId = v.client_id; //存储客户ID
          this.showSliderBoxSee = true;
        } else {
          return;
        }
      });
    },
    // 未到访暂不跟进
    ClickNoFloow() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postIsvisitData("-1", this.IsvisterReasonid);
          // this.visitingJG = false;
        } else {
          return;
        }
      });
    },
    // 已到访继续跟进
    ClickNoVisited(v) {
      this.visitedJG = false;
      this.isRoot = true;
      this.isTrack = true; //是否点击我要跟进
      this.from_client_id = v.client_id;
      this.followFormid = v.client_id; //跟进
      this.customerId = v.client_id; //存储客户ID
      this.showSliderBoxSee = true;
      // this.jumptoFollow();
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeInvitationauditionmanage
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      storeInvitationauditionmanage
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      (() => {})(query);
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    //绑定学员提交
    onBindSubmit() {
      // (() => {})(this.BindstudentFrom);
      storeInvitationauditionmanage
        .bindingClient({
          token: this.token,
          marketer_id: this.marketer_id,
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getClientinviteData();
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      this.showSliderBoxSee = false;
      this.showSliderBox = true;
    },
    //点击查看
    handleColumnChange(k, v) {
      this.isRoot = false;
      this.activeName = "first";
      this.iscanEdit = true;
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      this.sId = v.client_id;

      // this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      if (v.invite_type == 0) {
        // 流失学生
        this.isTrack = false;
        this.showSliderBoxSee = true;
      } else if (v.invite_type == 1) {
        this.isTrack = false;
        this.getCrmStudentOneApi(v.client_id);
        this.showLSSliderBoxSee = true;
      }
    },
    getCrmStudentOneApi(sid) {
      storeInvitationauditionmanage
        .getCrmStudentOneApi({
          student_id: sid,
          marketer_id: this.marketer_id,
        })
        .then((res) => {
          const { data } = res.data;
          this.campusrosterStuData = data;
          this.showSliderBoxSee = true;
        });
    },
    //跟进提交
    onFllowSubmit(v) {
      // v.track_intention_level = this.clientLevelNum.length;
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      if (this.followFormid != "") {
        v.client_id = this.followFormid;
      }
      (() => {})(v);
      storeInvitationauditionmanage.settingtrackClient(v).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getClientinviteData();
          this.showSliderBoxSee = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
      this.showLSSliderBoxSee = false;
      this.changeAppointVisible = false;
    },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 试听类型
    ClickAudition(v) {
      this.auditionGenre = v;
    },
    // 试听时间
    ClickAuditiontime(v) {
      (() => {})(v, 121213);
      this.Auditiontime = v;
    },
    handClickcompare(v) {
      this.ClassMessage = v;
      this.leaningVisible = false;
    },
    handClickcancel() {
      this.leaningVisible = false;
    },
    handleCloseLean(done) {
      this.$confirm(this.$t("Invitationauditionmanage.bn"))
        .then((_) => {
          this.leaningVisible = false;
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(localStorage.getItem("allinvitationColumns"));
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item, index) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage("showinvitationColumns", this.showColumns);
      this.settingVisible = false;
      this.getClientinviteData();
      (() => {})(allnum);
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    // 编辑列
    Changeoprate() {
      (() => {})(
        this.$t("views.Invitationauditionmanage.invitationManage.5474xx7uw340")
      );
    },
    hideSliderBox() {
      this.showSliderBox = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    onSubmit() {
      // (() => {})(this.form);
    },
    changeSize() {
      (() => {})("change");
    },
    handleSliderClick(v) {
      (() => {})(v), 11111111;
      if (v == "first") {
        this.iscanEdit = true;
        //  this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
        } else {
          this.iscanEdit = false;
          // this.isRoot=false;
        }
      }
    },
    handleOneClick(v1) {
      this.postIsvisitData("1", v1.invite_id);
      this.inviteInfor = v1;
      this.studentName_invited = v1.client_cnname;
    },
    handleTwoClick(v1) {
      this.reasonForm = {
        select: "",
        textarea: "",
      }; //数据情空
      this.visitingJG = true;
      this.getIsvisterReasonData();
      this.IsvisterReasonid = v1.invite_id;
      this.inviteInfor = v1;
      //  (() => {})(v1.client_id)
      // this.postIsvisitData("-1",this.IsvisterReasonid);
    },
    handleClick(v) {
      this.showSliderBox = true;
      (() => {})(v);
    },
    handleClose(done) {
      this.$confirm(this.$t("Invitationauditionmanage.bn"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pagesize = val;
      this.getClientinviteData()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val;
      this.getClientinviteData()
    },
    // tab切换
    addClass(index) {
      console.log( index)
      this.current = index;
      this.selectForm.invite_allisvisit = "";
      this.selectForm.cg_coursetype_id = "";
      this.selectForm.visitingTime = "";
      this.selectForm.startTime = "";
      this.selectForm.endTime = "";
      this.selectForm.chiefPerson = "";
      this.selectForm.keyword = "";
      this.selectForm.crm_stu_type = "";
      this.selectForm.coursetype_id = "";
      this.pagesize = 10;
      this.pagenum = 1;
      this.currentPage = 1;

        this.getClientinviteData()
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      let type = "";
      if (this.current == 0) {
        type = "0";
      } else if (this.current == 1) {
        type = "1";
      } else if (this.current == 2) {
        type = "-1";
      } else if (this.current == 3) {
        type = "2";
      } else if (this.current == 4) {
        type = "";
      }
      params_str = `&invite_isvisit=${type}&invite_visittime=${this.selectForm.visitingTime}&invite_starttime=${this.selectForm.startTime}&keyword=${this.selectForm.keyword}&invite_endtime=${this.selectForm.endTime}&main_marketer_id=${this.selectForm.chiefPerson}&crm_stu_type=${this.selectForm.crm_stu_type}&invite_allisvisit=${this.selectForm.invite_allisvisit}&cg_coursetype_id=${this.selectForm.cg_coursetype_id}`;
      let url = storeInvitationauditionmanage.getClientinvite1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 110
        );
      }
    });
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("Invitationauditionmanage.less");
.invitationManage {
  height: 100vh;
  font-size: 20px;
}
</style>
